import React from 'react';
import { Box, Typography } from '@mui/material';
import { ARIA_CARD_ACCENT } from '../ariaMessageTypes';

/**
 * First-contact calibration suggested answers (message.data.ariaMessageType = first_contact_calibration).
 * Admin Handsoff: display-only — chips reflect options but never trigger actions.
 * Question copy lives in message.text; this card only renders suggested answer chips.
 */
const AriaFirstContactCalibrationCard = ({ calibration }) => {
  const answers = calibration?.suggestedAnswers ?? [];
  if (!answers.length) return null;

  return (
    <Box
      sx={{
        width: { xs: '100%', sm: 340 },
        maxWidth: '100%',
        minWidth: { sm: 300 },
        borderRadius: '16px',
        bgcolor: 'background.paper',
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 8px 24px rgba(17, 24, 39, 0.06)',
        px: 1.5,
        py: 1.35,
      }}
    >
      <Typography
        sx={{
          fontSize: '0.625rem',
          fontWeight: 700,
          letterSpacing: '0.08em',
          color: 'text.disabled',
          lineHeight: 1.3,
          mb: 1,
        }}
      >
        SUGGESTED ANSWERS
      </Typography>

      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {answers.map((answer) => (
          <Box
            key={answer}
            component="span"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              px: 1.25,
              py: 0.65,
              borderRadius: '999px',
              bgcolor: 'background.paper',
              border: `1px solid ${ARIA_CARD_ACCENT}`,
              color: ARIA_CARD_ACCENT,
              fontSize: '0.75rem',
              fontWeight: 600,
              lineHeight: 1.35,
            }}
          >
            {answer}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default AriaFirstContactCalibrationCard;
